import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoginForm = _resolveComponent("LoginForm")
  const _component_TwoFactor = _resolveComponent("TwoFactor")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.showTwoFactor)
      ? _createVNode(_component_LoginForm, {
          key: 0,
          "onHandle-two-factor": _cache[1] || (_cache[1] = $event => (_ctx.showTwoFactor = true))
        })
      : _createCommentVNode("", true),
    (_ctx.showTwoFactor)
      ? _createVNode(_component_TwoFactor, { key: 1 })
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}